import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export const LOW_COUNT_THRESHOLD = 2
export const DEFAULT_SKIPS_REMAINING = 5

export class RecoveryCodesStatus {
  codesRemaining = 0
  totalCodes = 0
  generatedAt: Date | null = null
  skipsRemaining = DEFAULT_SKIPS_REMAINING
  /** When snooze expires (2 weeks after exhausting skips). Null if not snoozed. */
  skippedUntil: Date | null = null
  isTwoFactorEnabled = false
  /** Only returned for internal (rep) requests; false for customer-facing reads. */
  isRecoveryCodeLocked = false

  isRunningLow(): boolean {
    if (this.generatedAt === null) {
      return false
    }
    return this.codesRemaining <= LOW_COUNT_THRESHOLD
  }

  get isSnoozed(): boolean {
    return this.skippedUntil !== null && this.skippedUntil > new Date()
  }
}

export const RECOVERY_CODES_STATUS_DESER: SchemaDeSer<RecoveryCodesStatus> =
  new SchemaDeSerBuilder(RecoveryCodesStatus)
    .ofInt("codesRemaining", { jsonField: "recovery-codes-remaining" })
    .ofInt("totalCodes", { jsonField: "recovery-codes-total" })
    .ofDateTime("generatedAt")
    .ofInt("skipsRemaining", {
      jsonField: "recovery-code-generation-skips-remaining",
    })
    .ofDateTime("skippedUntil", "", "recovery-code-generation-skipped-until")
    .ofBoolean("isTwoFactorEnabled")
    .ofBoolean("isRecoveryCodeLocked")
    .toDeSer()
